import React from 'react';
import { Gradient, gradientName } from '../Gradient';

export type Props = {
  /**
   * Size of the icon in px, em, etc.
   */
  size: string;
  /*
   * Color of the icon as a hexadecimal.
   */
  color: string;
  /*
   * If true, the color will be a linear gradient, otherwise, it will use the
   * provided color.
   */
  gradient?: boolean;
};

export const BoltD: React.FC<Props> = ({
  gradient = false,
  ...props
}: Props) => {
  const { size, color } = props;
  const fill = gradient ? gradientName : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0568 0.0431531C13.244 0.132712 13.3432 0.340797 13.2949 0.542569L11.4495 8.25625H15.3358C15.5014 8.25625 15.6529 8.34914 15.728 8.49666C15.8031 8.64418 15.7891 8.82137 15.6918 8.95526L7.79107 19.8187C7.66763 19.9884 7.44152 20.0474 7.25092 19.9596C7.06031 19.8717 6.95824 19.6615 7.00707 19.4574L8.85244 11.7437H4.47236C4.30451 11.7437 4.15127 11.6483 4.07729 11.4976C4.00331 11.3469 4.02146 11.1673 4.12409 11.0345L12.5186 0.171046C12.6454 0.00688143 12.8697 -0.046406 13.0568 0.0431531ZM5.36869 10.8635H9.41029C9.54504 10.8635 9.67236 10.9252 9.75583 11.031C9.83929 11.1368 9.8697 11.275 9.83834 11.406L8.37629 17.5174L14.4715 9.13652H10.8917C10.7569 9.13652 10.6296 9.07479 10.5461 8.969C10.4627 8.86322 10.4323 8.72503 10.4636 8.59398L11.9619 2.33105L5.36869 10.8635Z"
        fill={fill}
      />
      <path
        d="M0 2H1.92584C2.39577 2 2.81324 2.09072 3.17827 2.27217C3.5433 2.4495 3.82651 2.70311 4.02791 3.03301C4.2293 3.3588 4.33 3.73612 4.33 4.165C4.33 4.59388 4.2293 4.97327 4.02791 5.30317C3.82651 5.62895 3.5433 5.88257 3.17827 6.06401C2.81324 6.24134 2.39577 6.33 1.92584 6.33H0V2ZM1.88808 5.64957C2.21115 5.64957 2.49436 5.58978 2.73772 5.47019C2.98527 5.34647 3.17407 5.17327 3.30414 4.95059C3.43841 4.72378 3.50554 4.46191 3.50554 4.165C3.50554 3.86809 3.43841 3.60829 3.30414 3.3856C3.17407 3.15879 2.98527 2.98559 2.73772 2.866C2.49436 2.74229 2.21115 2.68043 1.88808 2.68043H0.818169V5.64957H1.88808Z"
        fill={fill}
      />
      <defs>{gradient && <Gradient />}</defs>
    </svg>
  );
};
